import Plugin, { init } from "@/modules/_utils/Plugin";
import Swiper from "swiper";
import $ from "jquery";
window.jQuery = $;

class ProductDetail extends Plugin {
  init() {
    const productSlider = new Swiper("#gallery__swiper-container", {
      effect: "slide",
      grabCursor: false,
      slidesPerView: 4,
      spaceBetween: 0,
      slidesPerGroup: 1,
      loop: true,
      loopFillGroupWithBlank: true,
      simulateTouch: true,
      speed: 700,
      autoplay: {
        delay: 7000,
        disableOnInteraction: false
      },
      breakpoints: {
        575: {
          slidesPerView: 1
        }
      }
    });

    $("[data-popup]").on("click", function() {
      let src = $(this).data("popup");
      $("body").addClass("popup__active");
      $(".popup__wrapper").html('<img src="' + src + '"/>');
    });

    $(".popup__close").on("click", function() {
      $("body").removeClass("popup__active");
      $(".popup__wrapper").html("");
    });
  }
}

export default init(ProductDetail, "productDetail");
